import * as $ from 'jquery';
import SelectAddable from './select-addable';
import SelectAttached from './select-attached';

var LocationSelect = function($select, value)
{
    this.saveInstance();
    this.$select = $select;
    this.value = value;
    this.$button = $select.closest('.input-group').find('button.location-create-button');
    this.$container = $select.closest('div.form-group');
    this.$modal = this.$container.find('div.modal');

    this.setup();
};

LocationSelect.prototype.saveInstance = function()
{
    if (!window.Instances) window.Instances = [];
    if (!window.Instances.Locations) window.Instances.Locations = [];
    window.Instances.Locations.push(this);
};

LocationSelect.prototype.setup = function()
{
    // Save all data
    if (!window.Locations || window.Locations.length === 0)
    {
        window.Locations = [];

        // Save all Trainer data
        this.$select.find('option').each(function() {
            window.Locations.push({
                id: $(this).val(),
                name: $(this).html(),
                country: $(this).data('filter-value')
            });
        });

        // See if we have any trainers, if not... let's do an ajax request
        if (window.Locations.length === 0 && !LocationSelect.running)
        {
            LocationSelect.running = true;

            var self = this;
            $.ajax('/locations/ajax/', {
                method: 'GET',
                success: function(data)
                {
                    $.each(data, function(idx, item) {
                        // TODO: Check if the object doesn't already exists
                        window.Locations.push({
                            id: item.id,
                            name: item.name + ', ' + item.city + ', ' + item.country,
                            country: item.country
                        });
                    });

                    self.sortLocations();
                    // Fill the selects for all instances
                    $.each(window.Instances.Locations, function(idx, instance) {

                        var selected = instance.$select.find('option:selected');
                        if (selected.length > 0)
                        {
                            selected = selected.attr('value');
                        } else if (this.value)
                        {
                            selected = this.value;
                        }
                        console.log('Selected currently', selected);

                        // Remove all
                        instance.$select.find('option').remove();

                        if (instance.$select.find('option').length === 0)
                        {
                            $.each(window.Locations, function(idx, item) {
                                if (item)
                                {
                                    var $option = $('<option>', { value: item.id });
                                    $option.prop('selected', (item.id == selected));
                                    $option.html(item.name);
                                    $option.data('data-filter-value', item.country);
                                    instance.$select.append($option);
                                } else
                                {
                                    console.log('No item', idx, item);
                                }
                            });

                            instance.$select.selectpicker('refresh');

                            // Force selection
                            instance.$select.val(selected);
                        }
                    });

                },
                complete: function()
                {
                    LocationSelect.running = false;

                }
            });
        }
    }

    if (this.$modal.length === 0 && !LocationSelect.rendering)
    {
        LocationSelect.rendering = true;

        if (window.Modals && window.Modals.Locations && window.Modals.Locations.Add)
        {
            this.setupModal(window.Modals.Locations.Add.clone());
            LocationSelect.rendering = false;
        } else
        {
            $.ajax('/locations/ajax/modals/add', {
                method: 'GET',
                success: function(html)
                {
                    if (!window.Modals) window.Modals = [];
                    if (!window.Modals.Locations) window.Modals.Locations = [];
                    window.Modals.Locations.Add = $(html);

                    $.each(window.Instances.Locations, function(idx, instance) {
                        if (instance.$modal.length === 0)
                        {
                            instance.setupModal(window.Modals.Locations.Add.clone());
                        }
                    });
                },
                completed: function()
                {
                    LocationSelect.rendering = false;
                }
            });
        }
    } else if (!LocationSelect.rendering)
    {
        if (!window.Modals) window.Modals = [];
        if (!window.Modals.Locations) window.Modals.Locations = [];
        window.Modals.Locations.Add = this.$modal;
        this.setupAddable();
    }
};

LocationSelect.prototype.sortLocations = function()
{
    // Check if the first one has no id
    window.Locations = window.Locations.filter(function(value, index, arr) {
        return (value.id !== '');
    });

    // Sort the Trainers by name
    window.Locations.sort(function ( a, b ) {
        if ( a.name < b.name ){
            return -1;
        }
        if ( a.name > b.name ){
            return 1;
        }
        return 0;
    });

    window.Locations.unshift({
        id: '',
        name: 'Pick a location'
    });
};

LocationSelect.prototype.setupModal = function($modal)
{
    var $foundModal = this.$container.find('div.modal');
    if ($foundModal.length === 0)
    {
        this.$modal = $modal;
        this.$container.append($modal);
    } else
    {
        this.$modal = $foundModal;
    }

    // Setup the selectpickers for the modal
    this.$modal.find('select.selectpicker').each(function() {
        // Because the modal is possibly cloned we need to remove it from the container
        var $select = $(this),
            $selectContainer = $select.closest('div.bootstrap-select');

        $select.insertBefore($selectContainer);
        $selectContainer.remove();
        $select.selectpicker('refresh');
    });
    this.setupAddable();
};

LocationSelect.prototype.setupAddable = function()
{
    // Setup button functionality
    this.button_instance = new SelectAddable(
        this.$button,
        'fluffy-control-location',
        function(data) { return data.name; },
        function(data) { return data.country; }
    );

    this.button_instance.on('added', function(item)
    {
        window.Locations.push({
            id: item.id,
            name: item.name + ', ' + item.city + ', ' + item.country,
            country: item.country
        });
        this.sortLocations();
    }, this);
};

LocationSelect.prototype.create = function()
{
    if (window.Locations)
    {
        this.$select.empty();
        var self = this;

        // Fill the select
        $.each(window.Locations, function(idx, item) {
            var $option = $('<option>', { value: item.id });
            $option.html(item.name);
            $option.data({
                'filter-value': item.country
            });
            self.$select.append($option);
        });

        // Create input group
        var $inputGroup = $('<div/>', {class: 'input-group'});
        this.$select.wrap($inputGroup);

        // Add the button
        this.$inputGroupAppend = $('<div class="input-group-append"></div>');
        this.$button = $('<button class="btn btn-primary location-create-button"><i class="fa fa-plus"></i></button>');
        this.$inputGroupAppend.append(this.$button);
        this.$select.after( this.$inputGroupAppend );

        // Make it a select picker
        this.$select.data({
            container: 'body',
            'show-subtext': true,
            'live-search': true
        });
        this.$select.addClass('form-control selectpicker show-tick fluffy-control-location');

        if (this.value) this.$select.val(this.value);

        this.$select.selectpicker();

        // Connect location select to country
        this.$select.data({
            'attached-to': 'edition_country_code',
            'hide': true
        });

        setTimeout(function() {
            SelectAttached(self.$select);
            // Add the button functionality
            self.setup();
        }, 10);

    } else
    {
        console.log('No locations found yet');
    }
};

export default LocationSelect;